// const domain = 'http://api.yqkkn.com/';
const domain =
  process.env.NODE_ENV !== "production" ? "" : "https://fcaiapi.light22.net/";
const loginUrl = domain + "";
const psdCheck = domain + "redpkt/index/sendpkt";
// 默认配置
global.defConfig = {
  avatar: "//s.yqkkn.com/samo.png"
};
export default {
  domain,
  loginUrl,
  psdCheck
};
